import React from "react";
import Hero from "../components/Hero";
// import { Container } from "react-bootstrap";
// import Social from "../components/Social";
// import Gallery from "../components/Gallery";
import { motion } from "framer-motion";

// const pageTransition = {
//   hidden: { y: "100vh" },
//   shown: { y: 0, transition: { delay: 0.5, type: "linear" } },
//   exit: { x: "-100vw", transition: "easeInOut" },
// };

const Home = () => {
  return (
    <motion.div
      // variants={pageTransition}
      // initial="hidden"
      // animate="shown"
      // exit="exit"
      className="overflow-hidden vh-100"
    >
      <Hero />
      {/* <Container>
        <Social />
        <motion.h1
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.75 }}
          className="text-secondary text-center my-5 display-1 text-uppercase"
        >
          My Works
        </motion.h1>
        <Gallery />
      </Container> */}
    </motion.div>
  );
};

export default Home;
